module.exports = __webpack_public_path__ + "img/transactionCount.eec70060.png";